const generateType = (actionType = 'CUSTOM', reducer = 'TEMPLATE/LANDING') => `${reducer}/${actionType}`;

export const setConfigData = (list = null) => {
	return async (dispatch, getState) => {
		if (!list) return;

		await dispatch({
			type: generateType('SET'),
			payload: { scope: '', values: {} },
		});
	};
};
